const AppStoreBadge = () => (
  <a
    href="https://apps.apple.com/us/app/equiforge/id6775309718"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Download EquiForge on the App Store (opens in a new tab)"
    className="inline-flex shrink-0 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 focus-visible:ring-offset-4 focus-visible:ring-offset-slate-950"
  >
    <img
      src="/images/app-store-badge-white.png"
      alt="Download on the App Store"
      width={320}
      height={108}
      className="h-auto w-[160px] max-w-full rounded-[10px]"
    />
  </a>
);

export default AppStoreBadge;
